import { HttpParams } from '@angular/common/http';
import { LearningPortfolioParams } from './learning-portfolio.value';

type QueryParams = Record<string, string | number | readonly string[]>;

export class LearningPortfolioParamsDto {
    private readonly query: QueryParams = {};

    constructor(params: LearningPortfolioParams) {
        if (params.type?.length) this.query['type[]'] = params.type;
        if (params.categoryIds?.length) this.query['category[]'] = params.categoryIds;
        if (params.courseId) this.query['courseId'] = params.courseId;
        if (params.moduleId) this.query['moduleId'] = params.moduleId;
        if (params.lessonId) this.query['lessonId'] = params.lessonId;
        if (params.from) this.query['from'] = params.from;
        if (params.to) this.query['to'] = params.to;
        if (params.search) this.query['search'] = params.search;
        if (params.source) this.query['source'] = params.source;
        if (params.limit !== undefined) this.query['limit'] = params.limit;
        if (params.offset) this.query['offset'] = params.offset;
    }

    get params(): HttpParams {
        return new HttpParams({ fromObject: this.query });
    }
}
